import { RankedTester, and, isControl, optionIs, rankWith } from "@jsonforms/core";

const EventAttendanceSessionQrTester: RankedTester = rankWith(
  30,
  and(isControl, optionIs("EventAttendanceSessionQr", true))
);

export default EventAttendanceSessionQrTester;
